import { Moment } from 'moment';
import { IMenuItem } from 'phx-core/lib/date-picker/utils/types';

import { IAffixDropdownOption } from '@misc/affix-dropdown-input-field/affix-dropdown-input-field.module';

import { IMoment, moment } from '@lib/moment';
import { EntityState, EntityType } from '@lib/entity.const';
import {
  ILoad,
  ILocation,
  IOrder,
  IOrderItinerary,
  IServerLoad,
  IServerLocation,
  IServerOrder,
  IServerOrderItinerary,
  IUserFeedback,
} from './dispatch.interfaces';

export const ROUTE_DATE_FORMAT: string = 'MM/DD/YYYY';
export const WITHOUT_YEAR_FORMAT: string = 'MM/DD';
export const JOB_DATE_FORMAT: string = 'YYYY-MM-DD';
export const DEFAULT_DATE_TIME_FORMAT: string = 'MM/DD, hh:mmA';
export const DISPATCH_PLACES_INPUT_PLACEHOLDER: string = $localize`Search addresses, places, or latitude/longitude`;
export const MARKER_TOOLTIP_INFO_MSG: string = $localize`ETA is calculated from the end previous stop’s time window and is based on continuous driving on regular road conditions and does not take traffic into account.`;
export const TOOLTIP_TEXT: string = $localize`ETA is based on continuous driving on regular road conditions and does not take traffic into account`;
export const MODAL_WIDTH: number = 320;
export const HEADER_HEIGHT: number = 60;
export const CREATE_ROUTE_TEXT: string = $localize`Create Route`;
export const ADD_ORDER_TEXT: string = $localize`Add Order`;

export const TABLE_FETCH_ERROR_MESSAGE: string = $localize`Unable to fetch data`;

export const CURRENCY_DROPDOWN_OPTIONS: IAffixDropdownOption[] = [
  {
    label: $localize`USD $`,
    value: 'USD',
  },
  {
    label: $localize`CAD $`,
    value: 'CAD',
  },
];

export const VOLUME_DROPDOWN_OPTIONS: IAffixDropdownOption[] = [
  {
    label: 'Gal',
    value: 'usd',
  },
  {
    label: 'Ltr',
    value: 'lts',
  },
];

export const DISTANCE_DROPDOWN_OPTIONS: IAffixDropdownOption[] = [
  {
    label: 'KM',
    value: 'km',
  },
  {
    label: 'Miles',
    value: 'miles',
  },
];

export const DISPATCH_STATUSES: IDispatchStatuses = {
  cancelled: {
    label: $localize`Canceled`,
    backgroundColor: 'bg-red-50',
    tagType: 'negative',
    tagContrast: 'high',
  },
  completed: {
    label: $localize`Completed`,
    backgroundColor: 'bg-grey-50',
    tagType: 'neutral',
    tagContrast: 'high',
  },
  in_transit: {
    label: $localize`In Transit`,
    backgroundColor: 'bg-grey-5',
    tagType: 'neutral',
    tagContrast: 'low',
  },
  at_stop: {
    label: $localize`At Stop`,
    backgroundColor: 'bg-grey-5',
    tagType: 'neutral',
    tagContrast: 'low',
  },
  at_pickup_stop: {
    label: $localize`At Pickup Stop`,
    backgroundColor: 'bg-yellow-40',
    tagType: 'caution',
    tagContrast: 'high',
  },
  at_last_stop: {
    label: $localize`At Last Stop`,
    backgroundColor: 'bg-grey-5',
    tagType: 'neutral',
    tagContrast: 'low',
  },
  en_route_to_first_stop: {
    label: $localize`En route to first stop`,
    backgroundColor: 'bg-grey-50',
    tagType: 'neutral',
    tagContrast: 'high',
  },
  at_starting_location: {
    label: $localize`At starting location`,
    backgroundColor: 'bg-grey-50',
    tagType: 'neutral',
    tagContrast: 'high',
  },
  unassigned: {
    label: $localize`Unassigned`,
    backgroundColor: 'bg-yellow-40',
    tagType: 'caution',
    tagContrast: 'high',
  },
  assigned: {
    label: $localize`Assigned`,
    backgroundColor: 'bg-green-50',
    tagType: 'positive',
    tagContrast: 'high',
  },
  pending: {
    label: $localize`Pending`,
    backgroundColor: 'bg-yellow-40',
    tagType: 'caution',
    tagContrast: 'high',
  },
  planned: {
    label: $localize`Planned`,
    backgroundColor: 'bg-green-50',
    tagType: 'positive',
    tagContrast: 'high',
  },
  active: {
    label: $localize`Active`,
    backgroundColor: 'bg-green-50',
    tagType: 'positive',
    tagContrast: 'high',
  },
};

export const DISPATCH_DETAILS_TABS: IDispatchDetailsTab = {
  details: {
    label: $localize`Details`,
    value: 'details',
  },
  activity: {
    label: $localize`Activity`,
    value: 'activity',
  },
};

export const DAYS_OF_WEEK: string[] = [
  $localize`Sunday`,
  $localize`Monday`,
  $localize`Tuesday`,
  $localize`Wednesday`,
  $localize`Thursday`,
  $localize`Friday`,
  $localize`Saturday`,
];

export const PHOENIX_DATE_FILTER_MENU_ITEMS: IMenuItem[] = [
  {
    label: $localize`Today`,
    valueInDays: 1,
  },
  {
    label: $localize`Last 7 days`,
    valueInDays: -7,
  },
  {
    label: $localize`Last 14 days`,
    valueInDays: -14,
  },
  {
    label: $localize`Last 30 days`,
    valueInDays: -30,
  },
  {
    label: $localize`Last 60 days`,
    valueInDays: -60,
  },
];

export const DISPATCH_EXPERIMENT_FEEDBACK: IUserFeedback = {
  rating: 5,
  imporvementAreas: ['[Pricing]','[Functionality]','[Ease of use]','[Response Time]','[Connectivity]'],
};

export enum DISPATCH_DISPLAY_STATUSES {
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum DISPATCH_DATE_FORMATS {
  DATE = 'MM/DD',
  DATETIME = 'MM/DD, hh:mma',
  DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss',
  DATE_FORMAT = 'MM/DD/YYYY hh:mm A',
  DATE_FORMAT_AND_ZONE = 'MM/DD/YYYY hh:mm A z',
  DATETIME_AND_ZONE = 'MM/DD, hh:mm A z',
  TIME = 'hh:mma',
  TIME_FORMAT = 'hh:mm A',
  TIME_AND_ZONE = 'hh:mm A z',
}

export enum ETA_STATUSES {
  LATE = 'late',
  EARLY = 'early',
  ON_TIME = 'onTime',
}

export enum DISPATCH_STAGE_TYPE {
  PLAN = 'plan',
  IN_PROGRESS = 'in-progress',
  DONE = 'done',
}

export enum STATUSES {
  ASSIGNED = 'assigned',
  UNASSIGNED = 'unassigned',
  PENDING = 'pending',
  PLANNED = 'planned',
  AT_STARTING_LOCATION = 'at_starting_location',
  ENROUTE_TO_FIRST_STOP = 'en_route_to_first_stop',
  AT_PICKUP_STOP = 'at_pickup_stop',
  IN_TRANSIT = 'in_transit',
  AT_STOP = 'at_stop',
  AT_LAST_STOP = 'at_last_stop',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ACTIVE = 'active',
}

export enum DISPATCH_EXPERIMENT_TRACKING {
  UPSELL_SCREEN_VIEW = 'Dispatch - Pricing Experiment - Upsell Screen - View',
  UPSELL_SCREEN_PLAY_VIDEO = 'Dispatch - Pricing Experiment - Upsell Screen - Play Video',
  UPSELL_SCREEN_LEARN_MORE_CLICK = 'Dispatch - Pricing Experiment - Upsell Screen - Learn More CTA Click',
  UPSELL_SCREEN_START_TRIAL_CTA_CLICK = 'Dispatch - Pricing Experiment - Upsell Screen - Start Trial CTA Click',

  TUTORIALS_MODAL_VIEW = 'Dispatch - Pricing Experiment - Tutorials Modal - View',
  TUTORIALS_MODAL_CTA_CLICK = 'Dispatch - Pricing Experiment - Tutorials Modal - CTA Click',
  TUTORIALS_MODAL_VIDEO_CLICK = 'Dispatch - Pricing Experiment - Tutorials Modal - Video Click',
  TUTORIALS_MODAL_DISMISS = 'Dispatch - Pricing Experiment - Tutorial Modal - Dismiss',
  TUTORIALS_MODAL_CLOSE_VIDEO_PLAYER = 'Dispatch - Pricing Experiment - Tutorials Modal - Close Video Player',

  TOP_BANNER_UPGRADE_CTA_CLICK = 'Dispatch - Pricing Experiment - Top Banner - Upgrade Now Click',

  EMPTY_STATE_VIEW = 'Dispatch - Pricing Experiment - Empty State - View',
  EMPTY_STATE_WATCH_TUTORIALS_CTA_CLICK = 'Dispatch - Pricing Experiment - Empty State - Watch Tutorials CTA Click',
  EMPTY_STATE_CREATE_ROUTE_CTA_CLICK = 'Dispatch - Pricing Experiment - Empty State - Create Route CTA Click',

  LOCKED_EMPTY_STATE_VIEW = 'Dispatch - Pricing Experiment - Locked Empty State - View',
  LOCKED_EMPTY_STATE_CHECKOUT_CTA_CLICK = 'Dispatch - Pricing Experiment - Locked Empty State - Purchase Now Click',

  CHECKOUT_MODAL_VIEW = 'Dispatch - Pricing Experiment - Checkout Modal - View',
  CHECKOUT_MODAL_DISMISS = 'Dispatch - Pricing Experiment - Checkout Modal - Dismiss',
  CHECKOUT_MODAL_PURCHASE_CTA_CLICK = 'Dispatch - Pricing Experiment - Checkout Modal - Purchase CTA Click',
  CHECKOUT_MODAL_REMIND_ME_LATER_CTA_CLICK = 'Dispatch - Pricing Experiment - Checkout Modal - Remind Me Later CTA Click',

  FEEDBACK_MODAL_VIEW = 'Dispatch - Pricing Experiment - Feedback Modal - View',
  FEEDBACK_MODAL_RATE = 'Dispatch - Pricing Experiment - Feedback Modal - Rate',
  FEEDBACK_MODAL_DISMISS = 'Dispatch - Pricing Experiment - Feedback Modal - Dismiss',
  FEEDBACK_MODAL_SUBMIT_FEEDBACK = 'Dispatch - Pricing Experiment - Feedback Modal - Submit Feedback',
}

export interface IDropdownOption {
  label: string;
  key: string;
}

export interface IToastOption {
  msg: string;
  isError: boolean;
}

export interface IDispatchStatuses {
  [key: string]: {
    label: string;
    backgroundColor: string;
    tagType?: string;
    tagContrast?: string;
  };
}

export interface IDispatchDetailsTab {
  [key: string]: {
    label: string;
    value: string;
  }
}

export interface ISidebarSection {
  heading: string;
  detail?: string;
  subDetail?: string;
  isHighlighted?: boolean;
  isCompleted?: boolean;
  isAlwaysCompleted?: boolean;
  isOptional?: boolean;
  isStopSection?: boolean;
  stopNumber?: number;
  showTrail?: boolean;
  shouldHideCheckbox?: boolean;
  isInProgress?: boolean;
}

export interface ISidebarData {
  sections: ISidebarSection[];
  stopsDistance?: string;
  shouldShowStops: boolean;
}

export function getFormattedDateTime(datetime: string, format: string, timezone: string, spliceMeridiem: boolean): string {
  let formattedDatetime: string = moment.mapTz(datetime, timezone).format(format);
  if (spliceMeridiem) formattedDatetime = spliceTimeMeridiem(formattedDatetime);
  return formattedDatetime;
}

export function spliceTimeMeridiem(datetime: string): string {
  return datetime.replace(/ am|am| AM|AM/g, 'a').replace(/ pm|pm| PM|PM/g, 'p');
}

export function mapUserTimezone(timezone: string, date: Date): Moment {
  const timezoneOffset: number = moment.tz(timezone).utcOffset();
  return date && moment(date).utcOffset(timezoneOffset, true);
}

export function getUserTimeInISOString(date: Date | null, timezone: string): string | null {
  if (date) {
    const dateTime = moment.mapTz(moment(date).format(DISPATCH_DATE_FORMATS.DATE_TIME_FORMAT), timezone);
    return moment(dateTime).toISOString();
  }
  return null;
}

export function getCurrentTime(userTimeZone: string): Moment {
  return moment.mapTz(userTimeZone);
}

export function getUserTimezoneAbbr(timezone: string): string {
  return moment.mapTz(moment(), timezone).format('z');
}

export function getTimeWindow(earlyDate: string, lateDate: string, timeZone: string, format: string) {
  const startDate: string = earlyDate ?
    spliceTimeMeridiem(moment.mapTz(earlyDate, timeZone).format(format)) : null;
  const endDate: string = lateDate ?
    spliceTimeMeridiem(moment.mapTz(lateDate, timeZone).format(format)): null;
  return startDate && endDate ? `${startDate} – ${endDate}` : startDate || endDate;
}

export function getEarlyAndLateDate(jobDate: string, date: string, timezone: string) {
  if (!jobDate) return date;
  const jobDateObject = moment(jobDate);
  const day: number = jobDateObject.date();
  const month: number = jobDateObject.month();
  const year: number = jobDateObject.year();
  const timeWindowDate: IMoment = moment.mapTz(date, timezone).set({'year': year, 'month': month, 'date': day});
  return timeWindowDate.toISOString();
}

export function getDateString(date: Date): string {
  if (!date) return null;
  const year: number = date.getFullYear();
  let month: number | string = date.getMonth() + 1; // getMonth() is zero-based
  let day: number | string = date.getDate();

  // Pad month and day with leading zeros if necessary
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;

  return `${year}-${month}-${day}`;
}


export function isEntityStale(
  locatedAt: string,
  entityState: EntityState,
  entityType: EntityType,
): boolean {
  const { MOVING, IDLING } = EntityState;
  const { ASSET } = EntityType;
  const FOUR_HOURS_IN_SECS = 60 * 60 * 4;
  const TWENTY_FOUR_HOURS_IN_SECS = 60 * 60 * 24;
  const FORTY_HOURS_IN_SECS = 60 * 60 * 40;
  const staleThresholdInSecs: number = [MOVING, IDLING].includes(entityState) ? FOUR_HOURS_IN_SECS
    : entityType === ASSET ? FORTY_HOURS_IN_SECS : TWENTY_FOUR_HOURS_IN_SECS;
  return moment().diff(moment(locatedAt), 'seconds') > staleThresholdInSecs;
}

export function transformOrderItineraries(orderItineraries: IServerOrderItinerary[]): IOrderItinerary[] {
  return orderItineraries.map((orderItinerary: IServerOrderItinerary): IOrderItinerary => {
    return {
      id: orderItinerary.id,
      orderId: orderItinerary.order_id,
      stopType: orderItinerary.stop_type,
      orderLoads: orderItinerary.order_loads && transformDispatchLoads(orderItinerary.order_loads),
      dispatchLocation: orderItinerary.dispatch_location && transformDispatchLocation(orderItinerary.dispatch_location),
      loadingMethod: orderItinerary.loading_method,
      instructions: orderItinerary.instructions,
      loadType: orderItinerary.load_type,
      trailerType: orderItinerary.trailer_type,
      trailerSize: orderItinerary.trailer_size,
      trailerSizeUnit: orderItinerary.trailer_size_unit,
      number: orderItinerary.number,
      startingTrailer: orderItinerary.starting_trailer,
      startingTrailerId: orderItinerary.starting_trailer_id,
      startingTrailerNumber: orderItinerary.starting_trailer_number,
      endingTrailer: orderItinerary.ending_trailer,
      endingTrailerId: orderItinerary.ending_trailer_id,
      endingTrailerNumber: orderItinerary.ending_trailer_number,
      earlyDate: orderItinerary.early_date,
      lateDate: orderItinerary.late_date,
      jobDate: orderItinerary.job_date,
      order: orderItinerary.order && transformDispatchOrder(orderItinerary.order),
    };
  });
}

export function transformDispatchOrder(order: IServerOrder): IOrder {
  const {
    id,
    order_number,
    customer_location,
    document_ids,
    order_loads,
    notes,
    total_revenue,
    currency,
    estimate_distance_km,
  } = { ...order };
  return {
    id,
    orderNumber: order_number,
    customerLocation: customer_location && transformDispatchLocation(customer_location),
    documentIds: document_ids,
    orderLoads: order_loads && transformDispatchLoads(order_loads),
    notes,
    totalRevenue: total_revenue,
    currency,
    estimateDistanceKm: estimate_distance_km,
  };
}

export function transformDispatchLoads(loads: IServerLoad[]): ILoad[] {
  return loads.map((load: IServerLoad): ILoad => {
    return {
      id: load.id,
      description: load.description,
      quantity: load.quantity,
      weight: load.weight,
      weightUnit: load.weight_unit,
      revenue: load.revenue,
      revenueCurrency: load.revenue_currency,
    };
  });
}

export function transformDispatchLocation(location: IServerLocation): ILocation {
  return {
    id: location.id,
    name: location.name,
    lat: location.lat,
    lon: location.lon,
    timezone: location.timezone,
    createdAt: location.created_at,
    updatedAt: location.updated_at,
    startedAt: location.started_at,
    completedAt: location.completed_at,
    phone: location.phone,
    fax: location.phone_fax,
    email: location.email,
    address1: location.address1,
    address2: location.address2,
    city: location.city,
    state: location.state,
    zip: location.zip,
    country: location.country,
  };
}
